import { useEffect, useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { BidDetailsForm } from "@/components/admin/bids/BidDetailsForm";
import { Position } from "@/services/positionService";
import { axiosInstance } from "@/pages/auth/auth.context";
import { Card } from "@/components/ui/card";
import { useBidForm } from "@/hooks/useBidForm";
import { Loading } from "@/components/ui/loading";

export default function CreateEvent() {
  const { toast } = useToast();
  const [positions, setPositions] = useState<Position[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { form, handleSave, handleCreateEvent } = useBidForm("new");

  useEffect(() => {
    async function fetchPositions() {
      setIsLoading(true);
      try {
        const route = process.env.REACT_APP_BASE_API_URL + "position";
        const response = await axiosInstance.get(route);
        setPositions(response.data);
      } catch (error) {
        console.error("ERROR FETCHING POSITIONS", error);
        toast({
          title: "Error",
          description: "Unable to fetch positions.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    }

    fetchPositions();
  }, [toast]);

  return (
    <div className="container max-w-2xl mx-auto py-10 px-4">
      <Card className="mb-8">
        <div className="p-6">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Create New Event
          </h1>
          <p className="text-muted-foreground">
            Fill out the form below to create a new event. Required fields are
            marked with an asterisk (*).
          </p>
        </div>
      </Card>

      {isLoading ? (
        <Loading text="Loading positions..." />
      ) : (
        <BidDetailsForm positions={positions} eventId="new" />
      )}
    </div>
  );
}
